import Accordion from "@/components/Accordion";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@velaro/velaro-component-lib";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Footer(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: { ...workingLanguageConfig, ...updates }
    });
  };

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: { ...workingStyleConfig, ...updates }
    });
  };

  const socialEnabled = workingStyleConfig.enableSocialButtons ?? false;

  return (
    <Accordion.Item eventKey="footer" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Footer</Accordion.Title>
        <Accordion.SubTitle>
          Privacy policy link and social media buttons
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-6 space-y-4">
          <div>
            <div className="text-sm font-medium mb-2">Privacy Policy Title</div>
            <TextInput
              value={workingLanguageConfig.privacyTitle}
              setValue={(value) => updateLanguageConfig({ privacyTitle: value })}
              showEmojiButton={false}
              maxWordCount={15}
            />
            <div className="text-sm font-medium mb-2 mt-3">Privacy Policy Link</div>
            <TextInput
              value={workingLanguageConfig.privacyUrl}
              setValue={(value) => updateLanguageConfig({ privacyUrl: value })}
              showEmojiButton={false}
            />
          </div>

          <div className="border-t border-slate-200" />

          <div className="flex justify-between items-center">
            <div>
              <div className="text-sm font-medium">Social Media Buttons</div>
              <div className="text-xs text-slate-600">Show follow buttons in the chat footer</div>
            </div>
            <Toggle
              toggled={socialEnabled}
              changeToggle={() => updateStyleConfig({ enableSocialButtons: !socialEnabled })}
            />
          </div>

          {socialEnabled && (
            <div className="space-y-3">
              {(
                [
                  { label: "Facebook URL", field: "facebookUrl" },
                  { label: "Twitter / X URL", field: "twitterUrl" },
                  { label: "LinkedIn URL", field: "linkedInUrl" },
                  { label: "Google URL", field: "googleUrl" }
                ] as { label: string; field: keyof StyleConfigModel }[]
              ).map(({ label, field }) => (
                <div key={field}>
                  <div className="text-sm font-normal mb-1">{label}</div>
                  <input
                    type="url"
                    aria-label={label}
                    className="border border-slate-300 rounded-md p-2 w-full text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--color-primary)]"
                    placeholder="https://"
                    value={(workingStyleConfig[field] as string) ?? ""}
                    onChange={(e) => updateStyleConfig({ [field]: e.target.value })}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
